import { useTranslation } from "react-i18next";

import { Illustration } from "@atoms";
import { useAppDispatch, useAppSelector, useIsTeamsApp, useTeamsMeetConsent } from "@hooks";
import { getCalendarIntegrationType, redirectForCalendarConsent, withAsyncThunkErrorHandling } from "@lib/store";
import { Button } from "@molecules";
import { FlexCol, P } from "@quarks";
import { pxToRem } from "@utils";

interface Props {
  title?: string;
  message?: string;
  buttonText?: string;
  illustration?: "calendar" | "lostCalendarConnection";
}

export const WorkdayMeetingsEmptyTile = ({ title, message, buttonText, illustration = "calendar" }: Props) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const calendarIntegrationType = useAppSelector(getCalendarIntegrationType);

  const isTeamsApp = useIsTeamsApp();
  const { askForConsent } = useTeamsMeetConsent();

  const handleButtonClick = () => {
    if (isTeamsApp) {
      askForConsent();
    } else {
      dispatch(withAsyncThunkErrorHandling(() => redirectForCalendarConsent()));
    }
  };

  return (
    <div className="border p-8 rounded-lg bg-beige-200">
      <FlexCol
        alignItems="center"
        gap={8}>
        {illustration && (
          <Illustration
            illustration={illustration}
            size="80px"
          />
        )}

        <FlexCol
          alignItems={"center"}
          gap={16}
          width="295px">
          <P
            textAlign={"center"}
            maxWidth={pxToRem(300)}
            fontWeight="bold"
            color="currentColor">
            {title ?? t("meeting:CalendarBannerTitle")}
          </P>
          <P
            textAlign={"center"}
            maxWidth={pxToRem(300)}
            className="text-mapiq-black-500">
            {message ?? t("meeting:CalendarBannerMessage")}
          </P>

          <Button
            onClick={handleButtonClick}
            button={"tertiary"}>
            {buttonText ?? t("meeting:CalendarBannerButton", { calendarIntegrationType })}
          </Button>
        </FlexCol>
      </FlexCol>
    </div>
  );
};
